export const COOKIES_KEYS = {
  SELECTED_LOCALE: "selected-locale",
  IS_QA: "is-qa",
};
